import { clientApi } from 'api';

export const notificationToken = (isServer = false) => async (fcmToken: string) => {
  const response = await clientApi.patch('/notification', { fcmToken });

  return response;
};
